import React from 'react';
import StatusPage from '../components/StatusPage';
export default function Welcome() { return <StatusPage title="Welcome to the notebook." message="The good, the bad, and the things I’m still figuring out. Pick a story and start reading." icon="book"><a className="f1000-read-first" href="/start-here">Start with the reader’s guide</a></StatusPage>; }
